import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation } from '@jsverse/transloco';
import { catchError, Observable, of } from 'rxjs';

import { TranslationErrorHandler } from '../translation-error-handler';
import { TRANSLATION_SCOPE_IMPORTS } from '../translation-scope-imports.config';
import { TranslationUrlBuilder } from '../translation-url-builder';
import { TranslationLoadingStrategy } from './translation-loading-strategy.interface';

@Injectable({ providedIn: 'root' })
export class LocalTranslationStrategy implements TranslationLoadingStrategy {
  private http = inject(HttpClient);
  private urlBuilder = inject(TranslationUrlBuilder);

  loadGlobal(lang: string): Observable<Translation> {
    const url = this.urlBuilder.buildAssetUrl(lang);

    return this.http.get<Translation>(url).pipe(
      catchError((error) => {
        TranslationErrorHandler.logLocalTranslationError(lang, error);

        return of({} as Translation);
      }),
    );
  }

  async loadScoped(scope: string, lang: string): Promise<any> {
    const importFn = TRANSLATION_SCOPE_IMPORTS[scope];

    if (!importFn) {
      throw TranslationErrorHandler.handleScopeMappingError(scope, lang);
    }

    try {
      const translationModule = await importFn(lang);

      return translationModule.default || translationModule;
    } catch (error) {
      TranslationErrorHandler.handleLocalLoadError(scope, lang, error);
      throw error;
    }
  }
}
